<template>
  <div class="the-header">
    <div class="logo">
      <!-- <img src="@/assets/image/logo2.png" alt=""> -->
      依伴生态圈
    </div>
    <!-- <div class="btn-collapse" @click="$emit('collapse')">
      <i v-if="isExpand" class="el-icon-s-fold icon"></i>
      <i v-else class="el-icon-s-unfold icon"></i>
    </div> -->
    <el-menu mode="horizontal" text-color="#ffffff" active-text-color="#ffffff" :default-active="idx">
      <el-menu-item v-for="menu in rootMenus" :key="menu.path"
        :index="menu.path" @click="select(menu)">
        {{ menu.name }}
      </el-menu-item>
    </el-menu>
    <img class="avatar" src="@/assets/image/avatar.png" alt="头像">
    <span class="welcome">欢迎您，{{ userInfo.userName }}</span>
    <img class="fullscreen" src="@/assets/image/fullscreen.png" alt="全屏" @click="changeScreen">
    <img class="exit" src="@/assets/image/exit.png" alt="退出" @click="logout">
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'TheHeader',
  props: ['isExpand'],
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['userInfo', 'rootMenu', 'rootMenus']),
    ...mapGetters(['sideMenus']),
    idx () {
      return this.rootMenu.path
    }
  },
  methods: {
    ...mapMutations(['clear', 'setRootMenu', 'setLeafMenu', 'addTab']),
    logout () {
      this.$confirm('确定注销本次登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push('/login')
        this.clear()
      })
    },
    changeScreen () {
      if (document.fullscreenEnabled) {
        if (document.fullscreenElement) {
          document.exitFullscreen()
        } else {
          document.documentElement.requestFullscreen()
        }
      } else {
        this.$message.warning('抱歉，该浏览器暂不支持全屏显示')
      }
    },
    select (menu) {
      this.setRootMenu(menu)
      if (menu.path === '/home') {
        if (menu.path !== this.$route.path) {
          this.setLeafMenu({
            name: menu.name,
            path: menu.path,
            code: menu.code
          })
          this.$router.push(menu.path)
        }
      } else {
        if (this.sideMenus) {
          let leafMenu = this.sideMenus[0].children[0]
          if (leafMenu.path !== this.$route.path) {
            this.setLeafMenu({
              name: leafMenu.name,
              path: leafMenu.path,
              code: leafMenu.moduleCode
            })
            this.$router.push(leafMenu.path)
            this.addTab({
              leafMenu: {
                name: leafMenu.name,
                path: leafMenu.path,
                code: leafMenu.moduleCode
              },
              rootMenu: menu
            })
          }
        }
      }
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.the-header {
  display: flex;
  align-items: center;
  height: 60px;
  padding-right: 20px;
  background: linear-gradient(to right, #1f2e54 , #233f87);
  .logo {
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 240px;
    height: 100%;
    text-align: center;
    color: #fff;
    font-size: 26px;
    font-weight: bold;
    background: linear-gradient(to right, #1f2e54 , #1f2e54);
  }
  .btn-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 4px;
    &:hover, &:focus {
      border: none;
      background-color: rgba(255, 255, 255, 0.2);
    }
    .icon {
      color: #fff;
      font-size: 20px;
    }
  }
  .el-menu.el-menu--horizontal {
    display: flex;
    align-items: center;
    height: 35px;
    margin-right: auto;
    border-bottom: none;
    background: transparent;
    .el-menu-item {
      height: 100%;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border-bottom: none;
      border-radius: 4px;
      &.is-active, &:hover, &:focus {
        border: none;
        background: linear-gradient(to right, #2647ff , #3ba3ff);
      }
    }
  }
  .iconfont {
    color: #fff;
    font-size: 18px;
  }
  .avatar, .notice, .change-pwd, .fullscreen {
    width: 18px;
    height: 18px;
    margin-right: 25px;
    cursor: pointer;
  }
  .notice {
    position: relative;
    .dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      z-index: 1030;
    }
  }
  .fullscreen {
    margin-right: 30px;
  }
  .welcome {
    color: #fff;
    font-size: 12px;
    margin-right: 15px;
  }
  .exit {
    width: 22px;
    height: 18px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.the-header {
  .el-badge {
    sup {
      border: none;
    }
  }
}
</style>